import React from 'react';

import type { SvgIconProps, TextFieldProps } from '@mui/material';
import { TextField, InputAdornment, IconButton } from '@mui/material';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

type PasswordFieldProps = TextFieldProps;

export const PasswordField = React.forwardRef<
  HTMLDivElement,
  PasswordFieldProps
>((props, ref) => {
  const [isVisible, setIsVisible] = React.useState(false);

  const handleVisibilityClick = () => {
    setIsVisible((prevState) => !prevState);
  };

  const adornment = (
    <InputAdornment position="end">
      <IconButton size="small" onClick={handleVisibilityClick}>
        <SwitchableVisibilityIcon isVisible={isVisible} color="primary" />
      </IconButton>
    </InputAdornment>
  );

  return (
    <TextField
      {...props}
      ref={ref}
      InputProps={{ ...props.InputProps, endAdornment: adornment }}
      type={!isVisible ? 'password' : props.type ?? 'text'}
    />
  );
});

const SwitchableVisibilityIcon = ({
  isVisible,
  ...props
}: { isVisible: boolean } & SvgIconProps) => {
  return isVisible ? <VisibilityOff {...props} /> : <Visibility {...props} />;
};
